import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import confetti from 'canvas-confetti';
import { toast } from 'react-toastify';
import { IoIosArrowBack } from 'react-icons/io';
import { FaTrophy, FaGamepad } from 'react-icons/fa';
import { IoHomeSharp } from 'react-icons/io5';
import './GameResult.css';
import GameRating from './GameRating';

const GameResultModal = ({ open, onClose, result, stakeAmount }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [animateModal, setAnimateModal] = useState(false);
  const isWinner = result?.winner === result?.playerId;

  // Get result from location state or localStorage
  // const result = location.state?.result || JSON.parse(localStorage.getItem('gameResult'));
  // const stakeAmount = location.state?.stakeAmount || (result?.stakeAmount || 0);

  useEffect(() => {
    if (open) {
      setAnimateModal(true);
    } else {
      setAnimateModal(false);
    }
  }, [open]);

  useEffect(() => {
    if (result) {
      // First set show animation to trigger fade-in
      setShowAnimation(true);
      
      // Then set animate modal to trigger the bounce effect
      setTimeout(() => {
        setAnimateModal(true);
      }, 100);

      // Show toast notification
      if (isWinner) {
        toast.success('Congratulations! You won the game!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });

        // Launch confetti for winner
        const duration = 5000;
        const animationEnd = Date.now() + duration;
        const defaults = {
          startVelocity: 30,
          spread: 360,
          ticks: 60,
          zIndex: 9999,
          shapes: ['square', 'circle'],
          colors: ['#FFD700', '#B0FF4A', '#FF43B9', '#FFCC00', '#BD3193']
        };

        const randomInRange = (min, max) => Math.random() * (max - min) + min;

        const interval = setInterval(() => {
          const timeLeft = animationEnd - Date.now();

          if (timeLeft <= 0) {
            clearInterval(interval);
            return;
          }

          const particleCount = 50 * (timeLeft / duration);
          
          // Run confetti from multiple angles
          confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
          });

          confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
          });

          confetti({
            ...defaults,
            particleCount,
            gravity: 1.2,
            drift: 0,
            origin: { x: 0.5, y: 0 }
          });
        }, 250);
      } else {
        toast.info('Better luck next time!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });
      }

      // Clear result from localStorage after showing
      // localStorage.removeItem('gameResult');
    }
  }, [result, isWinner]);

  const handleClose = () => {
    setAnimateModal(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!open) return null;

  return (
    <>
      <div className={`game-result-overlay show`}>
        <div className={`game-result-modal ${animateModal ? 'animate' : ''} ${isWinner ? 'winner' : 'loser'}`}>
          <div className="game-result-header">
            <button className="back-button" onClick={handleClose}>
              <IoIosArrowBack size={24} />
            </button>
            <h2 className="game-result-title">
              Game {isWinner ? 'Won!' : 'Over'}
            </h2>
            <div></div>
          </div>

          <div className="result-icon-container">
            {isWinner ? (
              <div className="winner-trophy">
                <FaTrophy size={64} />
              </div>
            ) : (
              <div className="loser-icon">
                <FaGamepad size={64} />
              </div>
            )}
          </div>

          <div className="result-message-container">
            <h3 className={`result-message ${isWinner ? 'winner-text' : 'loser-text'}`}>
              {isWinner ? 'You Won! 🎉' : 'You Lost 😔'}
            </h3>
            {stakeAmount > 0 && (
              <div className="stake-message">
                {isWinner
                  ? <span>You won <strong>{stakeAmount}</strong> coins! 🎯</span>
                  : <span>You lost <strong>{stakeAmount}</strong> coins.</span>
                }
              </div>
            )}
          </div>

          <div className="game-result-actions">
            <button onClick={handleClose} className="play-again-button">
              <span>Close</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameResultModal;